import { createRouter, createWebHistory } from "vue-router";
import NotFound from "../views/PageNotFound.vue";

const routes = [
  {
    path: "/",
    name: "Preview",
    component: () => import("../views/HomeDark.vue"),
    meta: {
      title: "CENTIMX || Luis Rivas",
    },
  },
  {
    path: "/home-dark",
    name: "HomeDark",
    component: () => import("../views/HomeDark.vue"),
    meta: {
      title: "CENTIMX || Luis Rivas",
    },
  },
  {
    path: "/privacyPolicy",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
    meta: {
      title: "Aiuda Bot || Politica de privacidad ",
    },
  },
    {
    path: "/ratingsFenamac",
    name: "RatingsFenamac",
    component: () => import("../views/RatingsFenamac.vue"),
    meta: {
      title: "FENAMAC || Ratings ",
    },
  },
  {
    path: "/home-light",
    name: "HomeLight",
    component: () => import("../views/HomeLight.vue"),
    meta: {
      title: "CENTIMX || Luis Rivas",
    },
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
    meta: {
      title: "Not Found || CENTIMX",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
  window.scrollTo(0, 0);
});

export default router;
